// This will be the parent class for the common data of transaction_item, purchase_item, project_part_item, etc.

import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
export default class Item extends BaseModel {
  constructor({
    id,
    number,
    designation,
    description = undefined,
    parent = undefined,
    active = true,
    option = undefined,
    itemType = undefined,
    titleLevel = undefined,
    resource = undefined,
    adminType = undefined,
    quantity = undefined,
    unit = undefined,
    discount = undefined,
    taxCode = undefined,
    comment = undefined,
    calculated = false,
    sortOrder = undefined,
  }) {
    super(id, number, designation);
    this.description = description;
    this.parent = parent;
    this.active = active;
    this.option = option;
    this.itemType = itemType;
    this.titleLevel = titleLevel;
    this.resource = resource;
    this.adminType = adminType;
    this.quantity = quantity;
    this.unit = unit;
    this.discount = discount;
    this.taxCode = taxCode;
    this.comment = comment;
    this.calculated = calculated;
    this.sortOrder = sortOrder;
  }

  /**
   * We can only pass the attributes that are present for all the three tables
   */
  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '0.75fr'}),
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      new AT.RichTextAttribute({
        name: 'description',
        tableProperties: {
          header: 'hit-base.common.description',
          maxWidth: '1fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'quantity',
        decimalPrecision: 3,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.quantity',
          maxWidth: '0.75fr',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      new AT.FkUnitAttribute({
        name: 'unit',
        column: 'unit_id',
        joinPath: undefined, // Set in child class
        tableProperties: {
          header: 'hit-base.common.unit',
          maxWidth: '0.4fr',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      new AT.FkTaxCodeAttribute({
        name: 'taxCode',
        column: 'tax_code_id',
        joinPath: undefined, // Set in child class
        tableProperties: {
          header: 'hit-base.common.tax-code',
          maxWidth: '0.45fr',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      new AT.EnumerationAttribute({
        name: 'itemType',
        column: 'item_type',
        enumType: 'ITEM_TYPE',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.common.type',
          maxWidth: '2.5rem',
        },
      }),
      new AT.StringAttribute({
        name: 'titleLevel',
        column: 'title_level',
        tableProperties: {
          header: 'hit-app.transaction.title-level',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resource',
        column: 'resource_id',
        joinPath: undefined, // Set in child class
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.StringAttribute({
        name: 'comment',
        tableProperties: {
          header: 'hit-base.common.comment-short',
          maxWidth: '0.5fr',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      this.ACTIVE_ATTRIBUTE(),
      new AT.BooleanAttribute({
        name: 'option',
        tableProperties: {
          header: 'hit-app.common.option-short',
          maxWidth: '2.5rem',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      new AT.BooleanAttribute({
        name: 'calculated',
        column: 'quantity_calculated',
        tableProperties: {
          header: 'calculated',
        },
      }),
      new AT.StringAttribute({
        name: 'adminType',
        column: 'admin_type',
        tableProperties: {
          header: 'hit-app.transaction.admin-type',
          maxWidth: '0.35fr',
          hideByDefault: true,
          hideInEditionForItemTypes: ['COMMENT', 'TITLE'],
        },
      }),
      new AT.DecimalAttribute({
        name: 'discount',
        creationValue: 1,
        decimalPrecision: 4,
        tableProperties: {
          header: 'hit-app.common.discount',
          maxWidth: '0.45fr',
          hideInEditionForItemTypes: ['COMMENT', 'TITLE', 'ITEM_GROUP'],
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
    ];
  }

  static getItemIcon(itemTypeId) {
    switch (itemTypeId) {
      case 'TITLE':
        return null;
      case 'COMMENT':
        return 'comment';
      case 'ITEM':
        return 'build';
      case 'RESOURCE':
        return 'box';
      case 'ITEM_GROUP':
        return 'account_tree';
      default:
        return null;
    }
  }
}
